import React, { useState } from 'react';
import { FlaskConical, Boxes, ClipboardList, BarChart3 } from 'lucide-react';
import { RMMasterSection } from './costing/RMMasterSection';
import { FormulationsSection } from './costing/FormulationsSection';
import { CostSheetSection } from './costing/CostSheetSection';
import { ComparisonSection } from './costing/ComparisonSection';
import { GREEN, MUTED } from './costing/helpers';


const SUBTABS = [
  { id: 'rm', label: 'RM Master', icon: Boxes },
  { id: 'formulation', label: 'Formulations', icon: FlaskConical },
  { id: 'cost-sheet', label: 'Cost Sheet', icon: ClipboardList },
  { id: 'comparison', label: 'Comparison Chart', icon: BarChart3 },
];


export const ProductCostingTab = ({ refreshKey, products = [] }) => {
  const [sub, setSub] = useState('rm');


  return (
    <div data-testid="product-costing-tab">
      <div className="flex items-center gap-2 mb-1">
        <FlaskConical className="w-6 h-6" style={{ color: '#C05C35' }} />
        <h2 className="text-2xl md:text-3xl font-bold" style={{ color: GREEN }}>Product Costing</h2>
      </div>
      <p className="mb-4 text-sm" style={{ color: MUTED }}>Raw materials, feed formulations &amp; auto-computed cost sheets.</p>


      <div className="flex gap-1 mb-5 border-b" style={{ borderColor: '#E2DFD8' }}>
        {SUBTABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setSub(t.id)}
            data-testid={`costing-subtab-${t.id}`}
            className="px-4 py-2 text-sm font-medium flex items-center gap-1.5 -mb-px border-b-2 transition-colors"
            style={sub === t.id
              ? { color: GREEN, borderColor: GREEN }
              : { color: MUTED, borderColor: 'transparent' }}
          >
            <t.icon className="w-4 h-4" /> {t.label}
          </button>
        ))}
      </div>


      {sub === 'rm' && <RMMasterSection refreshKey={refreshKey} />}
      {sub === 'formulation' && <FormulationsSection products={products} refreshKey={refreshKey} />}
      {sub === 'cost-sheet' && <CostSheetSection refreshKey={refreshKey} />}
      {sub === 'comparison' && <ComparisonSection refreshKey={refreshKey} />}
    </div>
  );
};
